import * as React from 'react';
import * as ReactDOM from 'react-dom';

export default class ButtonGroupItem extends React.Component {
  render() {
    return <li>{this.props.children}</li>;
  }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-react-wrapper/src/button-group/ButtonGroupItem.tsx